// Extracted from WeekdayAvailabilityEditor.tsx: a component file may only
// export components (react-refresh/only-export-components), and this pure
// validator is shared with VisitorWidgetSettingsPage's Save handler.
import { WEEKDAYS, type WeeklyAvailability } from '@/types/visitor'

/**
 * Pure validation shared with the Save handler: every window needs both
 * times filled, open strictly before close, and windows within one day must
 * not overlap. HH:MM 24h strings compare correctly lexicographically.
 * Returns a translated message, or null when everything is valid.
 */
export function validateAvailability(
  availability: WeeklyAvailability,
  t: (key: string) => string
): string | null {
  for (const day of WEEKDAYS) {
    const windows = availability[day] ?? []
    for (const [open, close] of windows) {
      if (!open || !close) return t('availability.validation_incomplete')
      if (open >= close) return t('availability.validation_order')
    }
    const sorted = [...windows].sort((a, b) => (a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0))
    for (let i = 1; i < sorted.length; i++) {
      if (sorted[i][0] < sorted[i - 1][1]) return t('availability.validation_overlap')
    }
  }
  return null
}
